module.exports = __webpack_public_path__ + "img/ICRT_cancer_awarness_white_small.d80c6d6e.png";